<div class="error">
  <div class="content">
    <h3 class="pb-3">We're sorry, the page you are looking for does not exist!</h3>
    <button aria-label="Back to home" (click)="gotoHomepage()" class="btn btn-warning">BACK TO HOME</button>
  </div>
</div>